import { OrderAdDetail } from "@app/core/models/order-ad-detail.model";
import { OrderStatus } from "@core/enums/order-status";
import { OrderHeader } from "@core/models/order-header.model";

export class OrderStatusViewModel {

	// order-level status flags (boolean) from API
	draft = false;
	cancelled = false;
	
	// calculated order-level status flags (boolean)
	isNew = false;
	finished = false;
	started = false;
	waitingMaterial = false;
	
	// ad detail-level status counts from API
	approvalPendingAdCount = 0;
	rejectedAdCount = 0;
	confirmedAdCount  = 0;
	
	// calculated
	reservedAdCount = 0;
	reservedAll = false;
	confirmedAll = false;

	constructor (private readonly orderHeader: OrderHeader | undefined = undefined, private readonly adDetails: OrderAdDetail[] = []) {

		if (!orderHeader) return;

		let produced = false;
		for (const status of orderHeader.statusFlags || []) {
			const upperCaseStatus = status.toUpperCase();
			switch (upperCaseStatus) {
				case OrderStatus.Offer:
					this.draft = true;
					break;
				case OrderStatus.Produced:
					produced = true;
					break;
				case OrderStatus.Cancelled:
					this.cancelled = true;
					break;
			}
		}

		// Mutually exclusive to all of the below statuses
		if (this.cancelled) {
			return;
		}

		this.isNew = !orderHeader.id;

		// TODO when used for an edited order, the counts are not returned by calcPrice and so are out-of-date on the header
		// Update them in the costing response handling

		if (!this.cancelled && !this.draft && !this.isNew) {
			// TODO API bug adCountRemaining is wrong   
			// this.finished = orderHeader.adCountRemaining === 0 && orderHeader.adCount > 0;
			this.finished = orderHeader.endDate ? orderHeader.endDate <= (new Date()).toISOString() : false;
			if (!this.finished) {
				for (const status of Object.entries(orderHeader.statusCounts || {})) {
					const upperCaseStatus = status[0].toUpperCase();
					switch (upperCaseStatus) {
						case OrderStatus.ApprovalPending:
							this.approvalPendingAdCount = status[1] as number;
							break;
						case OrderStatus.Confirmed:
							this.confirmedAdCount = status[1] as number;
							break;
						case OrderStatus.Rejected:
							this.rejectedAdCount = status[1] as number;
							break;
					}
				}
				const newDetailCount = adDetails.reduce((acc, elem) => acc + (elem.id ? 0 : 1), 0);
				// TODO API bug adCountRemaining is wrong   
				//this.started = orderHeader.adCountRemaining > 0 && orderHeader.adCount > orderHeader.adCountRemaining;
				this.started = orderHeader.startDate ? orderHeader.startDate <= (new Date()).toISOString() : false;
				this.reservedAdCount = Math.max(0, orderHeader.adCount - newDetailCount - this.confirmedAdCount - this.approvalPendingAdCount - this.rejectedAdCount);
				this.reservedAll = this.reservedAdCount > 0 && this.reservedAdCount === orderHeader.adCount;
				this.confirmedAll = this.confirmedAdCount > 0 && this.confirmedAdCount === orderHeader.adCount;
				this.waitingMaterial = !produced && this.confirmedAdCount > 0;
			}
		}
	}
}
